"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var id = _ref.id,
      visuallyFocused = _ref.visuallyFocused,
      iconPosition = _ref.iconPosition,
      _onClick = _ref.onClick,
      option = _ref.option;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.dropdown
  }, /*#__PURE__*/_react["default"].createElement(DropdownMenuItemContainer, {
    visuallyFocused: visuallyFocused,
    onClick: function onClick() {
      _onClick(option.value);
    },
    id: id,
    role: "menuitem",
    tabIndex: -1
  }, iconPosition === "after" && /*#__PURE__*/_react["default"].createElement(DropdownMenuItemLabel, null, option.label), option.icon && /*#__PURE__*/_react["default"].createElement(DropdownMenuItemIcon, {
    iconPosition: iconPosition,
    label: option.label,
    role: typeof option.icon === "string" ? undefined : "img"
  }, typeof option.icon === "string" ? /*#__PURE__*/_react["default"].createElement("img", {
    src: option.icon
  }) : option.icon), iconPosition === "before" && /*#__PURE__*/_react["default"].createElement(DropdownMenuItemLabel, null, option.label)));
};

var DropdownMenuItemContainer = _styledComponents["default"].li(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  min-height: 36px;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  cursor: pointer;\n\n  ", "\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.optionIconSpacing;
}, function (props) {
  return props.theme.optionPaddingTop;
}, function (props) {
  return props.theme.optionPaddingBottom;
}, function (props) {
  return props.theme.optionPaddingLeft;
}, function (props) {
  return props.theme.optionPaddingRight;
}, function (props) {
  return props.visuallyFocused && "outline: ".concat(props.theme.focusColor, " solid 2px; outline-offset: -2px;");
}, function (props) {
  return props.theme.hoverOptionBackgroundColor;
}, function (props) {
  return props.theme.activeOptionBackgroundColor;
});

var DropdownMenuItemLabel = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: 1.5rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.optionFontFamily;
}, function (props) {
  return props.theme.optionFontSize;
}, function (props) {
  return props.theme.optionFontStyle;
}, function (props) {
  return props.theme.optionFontWeight;
}, function (props) {
  return props.theme.optionFontColor;
});

var DropdownMenuItemIcon = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  color: ", ";\n\n  img,\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return props.theme.optionIconColor;
}, function (props) {
  return props.theme.optionIconSize;
}, function (props) {
  return props.theme.optionIconSize;
});

var _default = /*#__PURE__*/_react["default"].memo(DropdownMenuItem);

exports["default"] = _default;